import { render, staticRenderFns } from "./main-permanent-sales.vue?vue&type=template&id=3895b819&scoped=true&"
import script from "./main-permanent-sales.vue?vue&type=script&lang=js&"
export * from "./main-permanent-sales.vue?vue&type=script&lang=js&"
import style0 from "./main-permanent-sales.vue?vue&type=style&index=0&id=3895b819&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3895b819",
  null
  
)

export default component.exports